<template>
  <div class="scene-module scene-science">
    <div class="overview-banner-wrapper">
      <div class="overview-banner-area w1200">
        <h1>知识付费</h1>
        <p>
          覆盖多种内容服务变现形式，打通知识付费全核心环节，轻松构建业务闭环
        </p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="h800">
      <div class="w1200 scene-block scene-block_column">
        <h6 class="scene-block-text mb64">
          用户引流、线上课堂、品牌推广、商业变现，全面构建知识付费闭环
        </h6>
        <img
          :src="require('@/assets/images/scenePic1.png')"
          class="scene-block-img__big"
        />
      </div>
    </div>
    <div class="scene-block-list">
      <div class="scene-block-item">
        <div class="scene-block w1200">
          <div class="scene-block-text">
            <h1>丰富全面的课程内容形式</h1>
            <p class="">
              课程管理：支持图文、音频、视频、直播、电子书等丰富多样的课程内容形式
            </p>
          </div>
          <img
            :src="require('@/assets/images/scenePic2.png')"
            alt=""
            class="scene-block-img"
          />
        </div>
      </div>
      <div class="scene-block-item">
        <div class="scene-block w1200 reverse">
          <div class="scene-block-text">
            <h1>适合多种场景的售卖方式</h1>
            <p class="">
              售卖场景：课程单独售卖、多个内容打包成专栏/大专栏、设置有效期的付费订阅会员......轻松找到适合不同场景的售卖变现方式
            </p>
          </div>
          <img
            :src="require('@/assets/images/scenePic3.png')"
            alt=""
            class="scene-block-img"
          />
        </div>
      </div>
      <div class="scene-block-item">
        <div class="scene-block w1200">
          <div class="scene-block-text">
            <h1>轻量易用的社群助学工具</h1>
            <p class="">
              打卡：可创建日历打卡、作业打卡、考试打卡等多种打卡任务，监督学员完成学习计划
            </p>
            <p class="mg">
              考试：支持批量导入题库和试卷库，可结合证书工具，考试结束合格自动生成荣誉证书，鼓励朋友圈转发
            </p>
          </div>
          <img
            :src="require('@/assets/images/scenePic4.png')"
            alt=""
            class="scene-block-img"
          />
        </div>
      </div>
      <div class="scene-block-item">
        <div class="scene-block w1200 reverse">
          <div class="scene-block-text">
            <h1>强力高效的营销裂变工具</h1>
            <p class="">
              营销工具：裂变、拼团、好友助力、推广员等数十种营销工具，贯通个人微信、社群、朋友圈、公众号等社交场景，持续不断实现获客转化
            </p>
          </div>
          <img
            :src="require('@/assets/images/scenePic5.png')"
            alt=""
            class="scene-block-img"
          />
        </div>
      </div>
      <div class="scene-block-item">
        <div class="scene-block w1200">
          <div class="scene-block-text">
            <h1>多个终端一键同步展现</h1>
            <p class="">
              全渠道经营：支持课程内容在公众号、小程序、朋友圈、微信群等主流社交终端获得曝光展现，轻松实现品牌触达和营销获客
            </p>
          </div>
          <img
            :src="require('@/assets/images/scenePic6.png')"
            alt=""
            class="scene-block-img"
          />
        </div>
      </div>
    </div>
    <v-case-list></v-case-list>
    <v-free
      v-if="$store.state.sceneClassName === 'app'"
      title="让您一分钟拥有自己的<br/>知识店铺"
      href=""
    ></v-free>
    <v-free v-else title="让您一分钟拥有自己的知识店铺" href=""></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import CaseList from '@/components/CaseList';
export default {
  name: 'sceneScience',
  components: {
    'v-free': Free,
    'v-case-list': CaseList
  }
};
</script>

<style lang="scss">
.scene-science {
  .overview-banner-wrapper {
    background-image: url('~@/assets/images/sceneBanner2.jpg');
  }
  .case-list {
    background-color: #fff;
  }
}
.app {
  .scene-science {
    .overview-banner-wrapper {
      height: 8.64rem;
      background-color: #1472ff;
      background-image: url('~@/assets/images/sceneBanner2_app.png');
      background-position: center;
      background-position-y: -0.96rem;
      background-size: cover;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.96rem 0.32rem 0;
      margin-top: 1.04rem;
      text-align: center;
      h1 {
        margin: 0;
        font-size: 0.8rem;
        font-weight: 600;
        color: #fff;
        line-height: 0.88rem;
      }
      p {
        margin-top: 0.24rem;
        margin-bottom: 0.48rem;
        font-size: 0.32rem;
        font-weight: 400;
        color: #fff;
        line-height: 0.48rem;
        width: 5.6rem;
      }
      a {
        border: none;
        outline: 0;
        margin: 0 auto;
        width: 3.2rem;
        height: 0.8rem;
        background: #fff;
        border-radius: 0.88rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #1472ff;
        line-height: 0.8rem;
        text-align: center;
      }
    }
    .scene-block {
      display: block;
      padding: 1.28rem 0.32rem;
      img {
        margin-top: 0.96rem;
        max-width: 100%;
      }
      .scene-block-text {
        width: auto;
        margin-bottom: 0;
        font-size: 0.56rem;
        font-weight: 500;
        color: #333;
        line-height: 0.72rem;
        h1 {
          font-size: 0.56rem;
          font-weight: 500;
          color: #333;
          line-height: 0.72rem;
        }
        p {
          margin-top: 0.32rem;
          font-size: 0.28rem;
          font-weight: 400;
          color: #333;
          line-height: 0.44rem;
        }
      }
      .scene-block-img {
        width: 100%;
      }
    }
    .case-list {
      background: #ffffff;
    }
  }
}
</style>
